import { render } from "./ReApproveTransfers.vue?vue&type=template&id=2d38f098"
import script from "./ReApproveTransfers.vue?vue&type=script&lang=js"
export * from "./ReApproveTransfers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__